import React from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import colors from '../../../../constants/colors';
import Accordion from 'app/components/Accordion';
import { desktopMinWidth } from '../../../../../utils/windowHelpers';
import { truncate } from '../../../../../utils/string';

const networkEndpoint = process.env.REACT_APP_BLOCKCHAIN_NETWORK_ENDPOINT;

const Details = ({ contractAddress, tokenId }) => {
  const useStyles = makeStyles(theme =>
    createStyles({
      root: {},
      detailContainer: {
        paddingTop: 18,
        [desktopMinWidth]: {
          paddingTop: 24,
        },
      },
      row: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: 18,
        [desktopMinWidth]: {
          marginBottom: 24,
        },
      },
      header: {
        fontSize: 16,
        color: colors.white_f2,
        fontWeight: 500,
        paddingBottom: 8,
        borderBottom: '1px solid #666666',
      },
      rowKey: {
        fontSize: 12,
        color: colors.gray_aa,
        fontWeight: 500,
        textTransform: 'uppercase',
      },
      rowValue: {
        fontSize: 14,
        color: colors.white_f2,
        '& a': {
          color: colors.white_f2,
          textDecoration: 'underline',
        },
      },
    }),
  );
  const classes = useStyles();
  return (
    <div>
      <Accordion
        isOpened={false}
        transitionTime={150}
        closedIconName="arrow-white-close"
        openIconName="arrow-white-open"
        trigger={<div className={classes.header}>Details</div>}
      >
        <div className={classes.detailContainer}>
          <div className={classes.row}>
            <div className={classes.rowKey}>Contract Address</div>
            <div className={classes.rowValue}>
              <a
                href={`${networkEndpoint}/address/${contractAddress}`}
                rel="noopener noreferrer"
                target="_blank"
              >
                {truncate(contractAddress, 16, '')}
              </a>
            </div>
          </div>
          <div className={classes.row}>
            <div className={classes.rowKey}>Token ID</div>
            <div className={classes.rowValue}>{tokenId}</div>
          </div>
          <div className={classes.row}>
            <div className={classes.rowKey}>Token Standard</div>
            <div className={classes.rowValue}>ERC-721</div>
          </div>
          <div className={classes.row}>
            <div className={classes.rowKey}>Blockchain</div>
            <div className={classes.rowValue}>Polygon</div>
          </div>
        </div>
      </Accordion>
    </div>
  );
};

export default Details;
